// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class SandboxTemplate {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        this.id = model.id;
        this.name = model.name;
        this.workspaceId = model.workspaceId;
        this.designSystemId = model.designSystemId;
        this.createdAt = new Date(model.createdAt);
        this.versions = (model.versions || []).map((v) => ({
            name: v.name,
            createdAt: new Date(v.createdAt),
            createdByUserId: v.createdByUserId,
            e2bTemplateId: v.e2bTemplateId,
            templates: v.templates,
            hasDesignModePlugin: v.hasDesignModePlugin,
        }));
    }
    toRemote() {
        return {
            id: this.id,
            name: this.name,
            workspaceId: this.workspaceId,
            designSystemId: this.designSystemId,
            createdAt: this.createdAt.toISOString(),
            versions: this.versions.map((v) => ({
                name: v.name,
                createdAt: v.createdAt.toISOString(),
                createdByUserId: v.createdByUserId,
                e2bTemplateId: v.e2bTemplateId,
                templates: v.templates,
                hasDesignModePlugin: v.hasDesignModePlugin,
            })),
        };
    }
}
